import { Injectable } from '@angular/core';
import {
  RouterEventsService,
  ConfigService
} from '@core-argos-angular-artifact/core';

@Injectable({
  providedIn: 'root'
})
export class GoodByeGuard {
  private readonly previousUrl = '/privacy';

  constructor(
    private readonly routerEventsService: RouterEventsService,
    private readonly configService: ConfigService
  ) {}

  canActivate(): boolean {
    if (this.routerEventsService.getCurrentUrl() !== this.previousUrl) {
      this.goTo(this.configService.getConfig()?.productUrl);
      return false;
    } else {
      return true;
    }
  }

  goTo(url: string): void {
    window.location.href = url;
  }
}
